module.exports = __webpack_public_path__ + "img/historia6.d32f49c4.jpg";